#import "../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"
query PurchaseOrderEmailStatusUpdate($id: UUID!) {
  purchaseOrder(id: $id) {
    __typename
    id
    
    _emailDocument {
      ...EmailDocumentFields
    }
    emailDocumentsByEntityId(orderBy: [_CREATED_DATE_DESC, PRIMARY_KEY_ASC]) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
  }
}
